import React, { useEffect, useState } from "react";

import * as S from "../styles";
import { Password } from "../../../components/Password";
import { sanitizeOnBlur } from "../../../helpers/sanitizeInput";
import { cpfMask, phoneMask } from "../../../../_metronic/_helpers/MasksHelper";
import { subscribeValidating } from "../validation";
import CollapsibleSection from "./CollapsibleSection";

const useValidatingFlag = kind => {
  const [active, setActive] = useState(false);
  useEffect(() => subscribeValidating(kind, setActive), [kind]);
  return active;
};

const IdentificationSection = ({
  formik,
  isUniqueEmail,
  isUniqueDocument,
  completed,
  emailInputRef,
  isPasswordlessCheckout,
}) => {
  const err = field => formik.errors[field] && formik.touched[field];
  const validatingEmail = useValidatingFlag("email");
  const validatingDocument = useValidatingFlag("cpf");

  return (
    <CollapsibleSection
      title={isPasswordlessCheckout ? "Identificação" : "Identificação e senha"}
      step={1}
      active
      completed={completed}
      summary={formik.values.email}
    >
      <S.Grid cols={2}>
        <S.Field>
          <label>
            Nome <span className="req">*</span>
          </label>
          <input
            type="text"
            name="name"
            className={`form-control ${err("name") ? "is-invalid" : ""}`}
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={e => {
              formik.setFieldValue("name", sanitizeOnBlur(e.target.value, "text"));
              formik.setFieldTouched("name", true);
            }}
            maxLength={64}
          />
          {err("name") && <span className="err">{formik.errors.name}</span>}
        </S.Field>

        <S.Field>
          <label>
            CPF <span className="req">*</span>
          </label>
          <S.CepFieldWrap $loading={validatingDocument}>
            <input
              type="text"
              name="document_number"
              placeholder="000.000.000-00"
              className={`form-control ${
                !validatingDocument && err("document_number") ? "is-invalid" : ""
              }`}
              value={formik.values.document_number}
              onChange={evt =>
                formik.setFieldValue("document_number", cpfMask(evt.target.value))
              }
              onBlur={() => formik.setFieldTouched("document_number", true)}
              aria-busy={validatingDocument}
            />
            {validatingDocument && <S.CepSpinner aria-hidden="true" />}
          </S.CepFieldWrap>
          {validatingDocument ? (
            <span className="hint">Verificando CPF...</span>
          ) : (
            err("document_number") && (
              <span className="err">
                {isUniqueDocument
                  ? "Este CPF já está cadastrado em nossa base."
                  : formik.errors.document_number}
              </span>
            )
          )}
        </S.Field>

        <S.Field>
          <label>
            E-mail <span className="req">*</span>
          </label>
          <S.CepFieldWrap $loading={validatingEmail}>
            <input
              ref={emailInputRef}
              type="text"
              name="email"
              className={`form-control ${
                !validatingEmail && err("email") ? "is-invalid" : ""
              }`}
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={e => {
                formik.setFieldValue("email", sanitizeOnBlur(e.target.value, "email"));
                formik.setFieldTouched("email", true);
              }}
              maxLength={64}
              aria-busy={validatingEmail}
            />
            {validatingEmail && <S.CepSpinner aria-hidden="true" />}
          </S.CepFieldWrap>
          {validatingEmail ? (
            <span className="hint">Verificando e-mail...</span>
          ) : (
            err("email") && (
              <span className="err">
                {isUniqueEmail
                  ? "Este e-mail já está cadastrado em nossa base."
                  : formik.errors.email}
              </span>
            )
          )}
        </S.Field>

        <S.Field>
          <label>
            Telefone <span className="req">*</span>
          </label>
          <input
            type="text"
            name="phone"
            placeholder="(00) 00000-0000"
            className={`form-control ${err("phone") ? "is-invalid" : ""}`}
            value={formik.values.phone}
            onChange={evt =>
              formik.setFieldValue("phone", phoneMask(evt.target.value))
            }
            onBlur={() => formik.setFieldTouched("phone", true)}
          />
          {err("phone") && <span className="err">{formik.errors.phone}</span>}
        </S.Field>

        {!isPasswordlessCheckout && (
          <>
            <S.Field>
              <label>
                Senha <span className="req">*</span>
              </label>
              <Password form={formik} showToggle />
            </S.Field>

            <S.Field>
              <label>
                Repetir senha <span className="req">*</span>
              </label>
              <Password form={formik} name="confirmation_password" showToggle />
            </S.Field>
          </>
        )}
      </S.Grid>
    </CollapsibleSection>
  );
};

export default IdentificationSection;
